import React, { useEffect, useState } from 'react';

let DEFAULT_VALUES = [];
export default function ReportsCurrentStock() {
  const [data, setData] = useState([]);
  const [dynamicColumns, setDynamicColumns] = useState([]);
  const [totalCount, setTotalCount] = useState(0);

  useEffect(() => {
    const getData = async () => {
      const json = { outlet_uuid: localStorage.getItem("outlet_uuid") }
      const url = `https://api.myfooddo.com/item/ViewCurrentStock`;
      // const url = `http://localhost:5000/item/ViewCurrentStock`;
      console.log(url, json)
      await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        body: JSON.stringify(json),
      })
        .then(res => res.json())
        .then(res => {
          console.log('data fetched from api --------- ', res?.result);
          if (res?.result?.length) {
            DEFAULT_VALUES = Array.from(res?.result);
            setData(res?.result);
            console.log(DEFAULT_VALUES)
            setTotalCount(res?.result?.length);
            setDynamicColumns(Object.keys(res?.result?.[0])?.filter((a) =>
              a !== 'item_uuid' &&
              a !== 'item_name' &&
              a !== 'item_units' &&
              a !== 'total'))
          };
        })
        .catch(err => console.warn("request failed", err));
    }
    getData();
    // console.log(data)
  }, []);

  const onUnitChange = (unitUuid, allUnits, itemId) => {
    const currentUnit = allUnits.find(a => a.unit_uuid === unitUuid);
    const denominator = currentUnit?.unit_denominator;
    const numerator = currentUnit?.unit_numerator;
    const values = JSON.parse(JSON.stringify(DEFAULT_VALUES));
    const x = data?.filter(a => a.item_uuid !== itemId);
    const y = values?.find(a => a.item_uuid === itemId);
    dynamicColumns.forEach((a => {
      y[a] = (denominator && numerator) ? (y[a] * +(+denominator / +numerator))?.toFixed(2) : y[a];
    }))
    y.total = (denominator && numerator) ? (y.total * +(+denominator / +numerator))?.toFixed(2) : y.total;
    setData([...x, y]);
  };

  return (
    <div className="accountGroup" style={{ background: 'white' }}>
      <div className='inventory_header'>
        <h2>Current Stock </h2>
      </div>

      <div className="topInputs">
        <div className="inputGroup" style={{ textAlign: 'right', padding: '5px 0' }}>
          <label htmlFor="Warehouse">Total Records: {totalCount}</label>
        </div>
      </div>
      <div className="items_table" style={{ flex: '1', paddingLeft: '5px',minWidth:'100%', width:'fit-content', overflow: 'auto' }}>
        {data.length &&
          <table className="f6 w-100 center" cellSpacing="0">
            <thead className="lh-copy">
              <tr className="white">
                <th className="pa2 tl bb b--black-20">Sr No.</th>
                <th className="pa2 tl bb b--black-20">Item Name</th>
                {dynamicColumns.length && dynamicColumns.map((a, i) =>
                  <th key={i} className="pa2 tl bb b--black-20" style={{ textTransform: 'capitalize',width:'10vw' }}>
                    {a.substr(a.indexOf('-') + 1, a.length).toLowerCase()}
                  </th>
                )}
                <th className="pa2 tl bb b--black-20">Total</th>
                <th className="pa2 tl bb b--black-20">Unit</th>
              </tr>
            </thead>
            <tbody className="lh-copy">
              {data?.sort((a, b) => a.item_name.localeCompare(b.item_name))?.map((a, index) =>
                <tr key={a + index}>
                  <td className="pa2 pl3 tl bb b--black-20">
                    {index + 1}
                  </td>
                  <td className="pa2 tl bb b--black-20">
                    {a.item_name || '-'}
                  </td>
                  {dynamicColumns.map((b, i) =>
                    <td key={b + i} className="pa2 tl bb b--black-20">
                      {a[b] || '-'}
                    </td>
                  )}
                  <td className="pa2 tl bb b--black-20">
                    {a.total || '-'}
                  </td>
                  <td className="pa2 tl bb b--black-20 w-20">
                    {a.item_units?.length ?
                      <select onChange={(e) => onUnitChange(e.target.value, a.item_units, a.item_uuid)}>
                        {a.item_units?.map((b =>
                          <option key={b.unit_uuid} value={b.unit_uuid}>{b.unit_name}</option>
                        ))}
                      </select>
                    : '-'}
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        }
      </div>
    </div>
  )
}
